// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1974":"summaryUserCache.worker","8335":"summarySlotCache.worker"}[chunkId] + "-" + {"1974":"c29d4c879cb19ce18535","8335":"b66b64f75f88a4604774"}[chunkId] + ".js";
};